import type { UmbLocalizationDictionary } from '@umbraco-cms/backoffice/localization-api';

export default {
  auth: {
    continue: 'Weiter',
    validate: 'Validieren',
    login: 'Anmelden',
    email: 'Bitte E-Mail eingeben',
    username: 'Bitte Benutzername eingeben',
    password: 'Kennwort',
    submit: 'Senden',
    required: 'Pflichtangabe',
    success: 'Erfolg',
    forgottenPassword: 'Kennwort vergessen?',
    forgottenPasswordInstruction: 'Es wird eine E-Mail mit einem Kennwort-Zurücksetzen-Link an die angegebene Adresse geschickt.',
    requestPasswordResetConfirmation: 'Es wird eine E-Mail mit Anweisungen zum Zurücksetzen des Kennwortes an die angegebene Adresse geschickt sofern diese im Datenbestand gefunden wurde.',
    setPasswordConfirmation: 'Ihr Kennwort wurde aktualisiert',
    rememberMe: 'Angemeldet bleiben',
    error: 'Fehler',
    defaultError: 'Ein unbekannter Fehler ist passiert.',
    errorInPasswordFormat: 'Für das Kennwort ist eine Mindestlänge von {0} Zeichen vorgesehen, wovon mindestens {1} Sonderzeichen (nicht alphanumerisch) sein müssen',
    passwordMismatch: 'Die Bestätigung Ihres Kennworts stimmt nicht mit dem angegebenen neuen Kennwort überein!',
    passwordMinLength: 'Ihr Kennwort muss mindestens {0} Zeichen lang sein.',
    passwordIsBlank: 'Ihr neues Kennwort darf nicht leer sein!',
    userFailedLogin: 'Hoppla! Wir konnten Sie nicht anmelden. Bitte überprüfen Sie Ihre Anmeldeinformationen und versuchen Sie es erneut.',
    userLockedOut: 'Ihr Konto wurde gesperrt. Bitte versuchen Sie es später erneut.',
    receivedErrorFromServer: 'Der Server hat einen Fehler gemeldet',
    resetCodeExpired: 'Der aufgerufene Link ist ungültig oder abgelaufen',
    userInviteWelcomeMessage: 'Hallo und Willkommen bei Umbraco! In nur einer Minute sind Sie bereit loszulegen, Sie müssen nur ein Kennwort festlegen.',
    userInviteExpiredMessage: 'Willkommen bei Umbraco! Bedauerlicherweise ist Ihre Einladung verfallen. Bitte kontaktieren Sie Ihren Administrator und bitten Sie ihn, diese erneut zu schicken.',
    newPassword: 'Neues Kennwort',
    confirmNewPassword: 'Neues Kennwort (Bestätigung)',
    greeting0: 'Willkommen',
    greeting1: 'Willkommen',
    greeting2: 'Willkommen',
    greeting3: 'Willkommen',
    greeting4: 'Willkommen',
    greeting5: 'Willkommen',
    greeting6: 'Willkommen',
    mfaTitle: 'Ein letzter Schritt',
    mfaCodeInputHelp: 'Geben Sie den Code aus Ihrer Authentifizierungs-App ein',
    mfaText: 'Sie haben die Multi-Faktor-Authentifizierung aktiviert und müssen Ihre Identität bestätigen.',
    mfaMultipleText: 'Bitte wählen Sie einen Multi-Faktor-Anbieter',
    mfaCodeInput: 'Bestätigungscode',
    mfaInvalidCode: 'Ungültiger Code eingegeben',
    signInWith: 'Anmelden mit {0}',
    returnToLogin: 'Zurück zur Anmeldung',
    localLoginDisabled: 'Leider ist eine direkte Anmeldung nicht möglich. Sie wurde von einem Anbieter deaktiviert.',
    friendlyGreeting: 'Hallo!',
  },
} satisfies UmbLocalizationDictionary;
